var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.page)?_c('div',{staticClass:"page"},_vm._l((_vm.page.grids),function(grid){return _c('Grid',{key:`grid-${grid.id}`,attrs:{"grid":grid}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }